import React from "react";
import ItemValue from "../overview/itemValue";
import { IRealtimeData } from "../../../types";
import { Card, CardContent, CardHeader } from "@mui/material";
import { DashboardSchemaType } from "../../interruptions/types";
import AcquisitionChartWrapper from "../../dashboardRT/components/widgets/chart/acquisitionChartWrapper";
import { IDashboard } from "../../dashboardRT/types";

interface IProps {
  realtimeData: Record<string, IRealtimeData>;
  schemas: Record<DashboardSchemaType, any> | null;
  width: number;
}

const dashboard: IDashboard = {
  dashboardID: null,
  moduleID: 2,
  nodeType: "",
  nodeID: 0,
  name: "",
  layout: {
    components:[
      {
        key: "ld4n9enfycyo2o8ic4",
        title: "Variables",
        componentType: 1,
        column: 1,
        row: 1,
        columnSpan: 1,
        rowSpan: 1,
        config: {
          acquisitionCell: {
            key: "ld4n9io2v50wiak3e7o",
            module: 2,
            title: "Name",
            machine: "EAF",
            variables: [
              {
                hash: "ld4nadw96zh1jnfwl4c",
                field: "LRFLOG.COMPARTMENT_1_DIFF_PRESS",
                title: "Compartment 1",
                color: "#ef5350",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "Pressure",
                  minimum: 0,
                  maximum: 10,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw93zh1jnfwl4c",
                field: "LRFLOG.COMPARTMENT_2_DIFF_PRESS",
                title: "Compartment 2",
                color: "#ec407a",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "Pressure",
                  minimum: 0,
                  maximum: 10,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw90zh1jnfwl4c",
                field: "LRFLOG.COMPARTMENT_3_DIFF_PRESS",
                title: "Compartment 3",
                color: "#ab47bc",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "Pressure",
                  minimum: 0,
                  maximum: 10,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw97zh1jnfwl4c",
                field: "LRFLOG.COMPARTMENT_4_DIFF_PRESS",
                title: "Compartment 4",
                color: "#7e57c2",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "Pressure",
                  minimum: 0,
                  maximum: 10,
                  ticksCount: 5
                }
              },
              {
                hash: "ld4nadw94zh1jnfwl4c",
                field: "LRFLOG.OVERRALL_DIFF_PRESS",
                title: "Compartment 5",
                color: "#5c6bc0",
                unit: "",
                decimals: 2,
                limits: [],
                annotations: [],
                yAxis: {
                  name: "Pressure",
                  minimum: 0,
                  maximum: 10,
                  ticksCount: 5
                }
              }
            ],
            events: []
          }
        }
      }
    ],
    palette:{

    }
  },
  userID: 0,
  owner: null,
  isPrivate: true,
  isDefault: false,
  isAcquisition: true,
  customConfig: {
    range: 8,
    fontSize: 1,
    scan: 1000
  },
  rtModule: true
}


const EAFDiffPress = ({ realtimeData, schemas, width }: IProps) => {

  return (
    <Card>
      <CardHeader title="LRF" sx={{ background: "rgba(0, 0, 0, 0.1)" }} />
      <CardContent sx={{ padding: 0 }}>
        <div className="m-2 display-grid gap-1" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr" }}>
          <div style={{ gridColumn: "1/6", marginBottom: "1em" }}>
            {schemas &&
              <AcquisitionChartWrapper
                realtime={realtimeData}
                component={dashboard.layout.components[0]}
                dashboard={dashboard}
                runtime={true}
                parentSize={{ width, height: 250 }}
                setDashboard={() => {
                }}
                schemas={schemas}/>
            }
          </div>
          <ItemValue title="COMPARTMENT 1"
                     value={realtimeData["LRFLOG.COMPARTMENT_1_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 2"
                     value={realtimeData["LRFLOG.COMPARTMENT_2_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 3"
                     value={realtimeData["LRFLOG.COMPARTMENT_3_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="COMPARTMENT 4"
                     value={realtimeData["LRFLOG.COMPARTMENT_4_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
          <ItemValue title="LRF OVERALL"
                     value={realtimeData["LRFLOG.OVERRALL_DIFF_PRESS"]?.Value}
                     color="green"
                     background="rgba(0, 0, 0, 0.5)"
                     fontSize="2em"/>
        </div>
      </CardContent>
    </Card>
  );
}

export default EAFDiffPress;